import { createFinishStepContent } from '../FinishStepContent';
import { closeSidebarPanel, openMarketingChannelsSubmenu } from '../sidebarHelpers';

const exploreEmailAnalytics = (baseUrl, navigate, user) => {
  const firstEmailSelector = '[data-email-name]:first-child';

  return {
    id: 'exploreEmailAnalytics',
    title: 'Explore Email analytics',
    steps: [
      {
        selector: '[data-tour="marketingChannelsLink"]',
        content: <p>Click on the "Marketing Channels" menu item in the navigation.</p>,
      },
      {
        actionBefore: () => openMarketingChannelsSubmenu('[data-tour="emailsLink"]'),
        selector: '[data-tour="emailsLink"]',
        content: <p>Click on the "Emails" in the navigation.</p>,
      },
      {
        actionBefore: () => {
          closeSidebarPanel();
          navigate(`${baseUrl}/emails`, true);
        },
        selector: firstEmailSelector,
        content: (
          <p>
            Each element in Releva has dedicated performance statistics. Here you can see the performance of each of
            your emails.
          </p>
        ),
      },
      {
        selector: '[data-tour="metricsSelector"]',
        content: (
          <p>
            The stats you see below are for the time frame you selected here. This period can be as long as you want or
            as short as a day.
          </p>
        ),
      },
      {
        selector: `${firstEmailSelector} [data-tour="emailSentStats"]`,
        content: <p>The Sent emails stat refers to the number of emails sent in the time frame you selected.</p>,
      },
      {
        selector: `${firstEmailSelector} [data-tour="emailDeliveredStats"]`,
        content: <p>Here is shown the number of successfully delivered emails.</p>,
      },
      {
        selector: `${firstEmailSelector} [data-tour="emailOpenedStats"]`,
        content: <p>This is the number of emails that were successfully delivered and users actually opened.</p>,
      },
      {
        selector: `${firstEmailSelector} [data-tour="emailClicksStats"]`,
        content: <p>Here you can see how many recipients clicked on the links in your email.</p>,
      },
      {
        selector: `${firstEmailSelector} [data-tour="emailPurchaseStats"]`,
        content: (
          <p>
            This stat reflects the number of completed purchases after the users came back to your website from this
            particular email.
          </p>
        ),
      },
      {
        selector: `${firstEmailSelector} [data-tour="emailRevenueStats"]`,
        content: (
          <p>
            Here is the total amount of revenue that users created after coming back to the website after an email
            campaign. In this case, each cart total is added to this number.
          </p>
        ),
      },
      {
        selector: `${firstEmailSelector} [data-tour="emailBouncesStats"]`,
        content: <p>We also give you the number of recipients that we received bounces from for one reason or another.</p>,
      },
      {
        selector: `${firstEmailSelector} [data-tour="emailComplaintsStats"]`,
        content: <p>This stat shows when someone has added your messages to spam.</p>,
      },
      {
        selector: `${firstEmailSelector} [data-tour="emailUnsubscribesStats"]`,
        content: (
          <p>
            And you can also see the number of users that choose to unsubscribe after they received this particular
            email.
          </p>
        ),
      },
      {
        actionBefore: () => navigate(`${baseUrl}/guide`, true),
        selector: '[data-tour="userGuideHeading"]',
        content: createFinishStepContent(),
      },
    ],
    isComplete: !!user.userActions.find(
      (a) => a.action === 'taskCompleted' && a.context.task === 'exploreEmailAnalytics'
    ),
  };
};

export default exploreEmailAnalytics;
